import { IconButton } from '../IconButton'
import { BareInput, InputStyling } from '../Input'
import { StyleFn } from '..'

// FIXME do we reuse ds-iconbutton component instead of a specific icon button style ?

export const NumericInput: StyleFn = (theme) => {
  const { color, opacity, size } = theme
  const { root: bareInput } = BareInput(theme)
  const { root: input, _focused, _valid, _invalid, _small } = InputStyling(theme)
  const { root: button, _ghost: buttonGhost, _small: smallButton } = IconButton(theme)

  return {
    root: {
      ...input,
      display: 'inline-flex',
      padding: 0,
      '&:focus-within': _focused,
    },
    _valid: {
      ..._valid,
      '&:focus-within': {
        boxShadow: `0 0 0 2px ${color.feedback.success.default} !important`,
      },
    },
    _invalid: {
      ..._invalid,
      '&:focus-within': {
        boxShadow: `0 0 0 2px ${color.feedback.error.default} !important`,
      },
    },
    _disabled: {
      userSelect: 'none',
      pointerEvents: 'none',
      opacity: opacity.disabled,
    },
    _small: {
      ..._small,
      paddingTop: 0,
      paddingBottom: 0,
      '& $button': {
        ...smallButton,
        minHeight: `calc(2rem - 1px)`,
      },
      '& $input': {
        margin: `0 ${size.spacing[12]}`,
      },
    },
    input: {
      ...bareInput,
      textAlign: 'center',
      margin: `0 ${size.spacing[16]}`,
      // type="number" resets
      // see https://www.w3schools.com/howto/howto_css_hide_arrow_number.asp
      // Chrome, Safari, Edge, Opera
      '&::-webkit-inner-spin-button, &::-webkit-outer-spin-button': {
        ['-webkit-appearance']: 'none',
        margin: 0,
      },
      '&[type=number]': {
        padding: 0,
        // Firefox
        ['-moz-appearance']: 'textfield',
      },
    },
    button: {
      ...button,
      ...buttonGhost,
      backgroundColor: color.type === 'light' ? color.palette.warmgrey[30] : 'rgba(255, 255, 255, 0.45)',
      minHeight: `calc(2.5rem - 1px)`,
      marginBottom: 1,
      borderRadius: 0,
      '&:first-child': { borderTopLeftRadius: 3 },
      '&:last-child': { borderTopRightRadius: 3 },
      // FIXME hover color not designed in UIKit
      '&:hover': { backgroundColor: color.palette.warmgrey[40] },
    },
  }
}
